<template>
    <div class="social">
        <a v-if="socials.testgoogle" :href="socials.testgoogle.url" @click.prevent="$emit('link-social', socials.testgoogle.url)" class="social__link google">
            <span class="icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_12178_112752)">
                    <path d="M12.4043 10.5508V14.5026H17.896C17.6548 15.7735 16.9312 16.8497 15.8458 17.5732L19.1575 20.1429C21.087 18.3618 22.2002 15.7458 22.2002 12.6381C22.2002 11.9146 22.1353 11.2187 22.0147 10.5509L12.4043 10.5508Z" fill="#4285F4"/>
                    <path d="M6.68617 14.3486L5.93925 14.9204L3.29541 16.9798C4.97445 20.3101 8.41577 22.6107 12.4046 22.6107C15.1597 22.6107 17.4695 21.7016 19.1579 20.1432L15.8462 17.5735C14.9371 18.1858 13.7775 18.5569 12.4046 18.5569C9.75157 18.5569 7.49745 16.7665 6.69034 14.3545L6.68617 14.3486Z" fill="#34A853"/>
                    <path d="M3.29523 7.83301C2.59953 9.2059 2.20068 10.7551 2.20068 12.4063C2.20068 14.0576 2.59953 15.6068 3.29523 16.9797C3.29523 16.9889 6.69048 14.3451 6.69048 14.3451C6.4864 13.7328 6.36577 13.0835 6.36577 12.4062C6.36577 11.7289 6.4864 11.0796 6.69048 10.4674L3.29523 7.83301Z" fill="#FBBC05"/>
                    <path d="M12.4048 6.26434C13.9077 6.26434 15.2434 6.78382 16.3102 7.78572L19.2323 4.86361C17.4605 3.21239 15.16 2.20117 12.4048 2.20117C8.41598 2.20117 4.97445 4.4925 3.29541 7.83211L6.69056 10.4667C7.49757 8.05473 9.75178 6.26434 12.4048 6.26434Z" fill="#EA4335"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_12178_112752">
                    <rect width="20" height="20.4085" fill="white" transform="translate(2.2002 2.20312)"/>
                    </clipPath>
                    </defs>
                </svg>
            </span>
            <span class="text" v-html="$t('Log in with {social}', { social: '<span>Google</span>' })"></span>
        </a>
        <a v-else-if="socials.google" :href="socials.google.url" @click.prevent="$emit('link-social', socials.google.url)" class="social__link google">
            <span class="icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_12178_112752)">
                    <path d="M12.4043 10.5508V14.5026H17.896C17.6548 15.7735 16.9312 16.8497 15.8458 17.5732L19.1575 20.1429C21.087 18.3618 22.2002 15.7458 22.2002 12.6381C22.2002 11.9146 22.1353 11.2187 22.0147 10.5509L12.4043 10.5508Z" fill="#4285F4"/>
                    <path d="M6.68617 14.3486L5.93925 14.9204L3.29541 16.9798C4.97445 20.3101 8.41577 22.6107 12.4046 22.6107C15.1597 22.6107 17.4695 21.7016 19.1579 20.1432L15.8462 17.5735C14.9371 18.1858 13.7775 18.5569 12.4046 18.5569C9.75157 18.5569 7.49745 16.7665 6.69034 14.3545L6.68617 14.3486Z" fill="#34A853"/>
                    <path d="M3.29523 7.83301C2.59953 9.2059 2.20068 10.7551 2.20068 12.4063C2.20068 14.0576 2.59953 15.6068 3.29523 16.9797C3.29523 16.9889 6.69048 14.3451 6.69048 14.3451C6.4864 13.7328 6.36577 13.0835 6.36577 12.4062C6.36577 11.7289 6.4864 11.0796 6.69048 10.4674L3.29523 7.83301Z" fill="#FBBC05"/>
                    <path d="M12.4048 6.26434C13.9077 6.26434 15.2434 6.78382 16.3102 7.78572L19.2323 4.86361C17.4605 3.21239 15.16 2.20117 12.4048 2.20117C8.41598 2.20117 4.97445 4.4925 3.29541 7.83211L6.69056 10.4667C7.49757 8.05473 9.75178 6.26434 12.4048 6.26434Z" fill="#EA4335"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_12178_112752">
                    <rect width="20" height="20.4085" fill="white" transform="translate(2.2002 2.20312)"/>
                    </clipPath>
                    </defs>
                </svg>
            </span>
            <span class="text" v-html="$t('Log in with {social}', { social: '<span>Google</span>' })"></span>
        </a>
        <div class="social__block">
            <span @click.prevent="$emit('change-type', 'login')" class="social__link email">
                <span class="icon">
                    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 5.92801C2.5 5.35969 2.72576 4.81465 3.12763 4.41278C3.52949 4.01092 4.07454 3.78516 4.64286 3.78516H20.3571C20.9255 3.78516 21.4705 4.01092 21.8724 4.41278C22.2742 4.81465 22.5 5.35969 22.5 5.92801V6.41658L13.0471 12.7194C12.8828 12.8202 12.6928 12.8713 12.5 12.8666C12.3072 12.8713 12.1172 12.8202 11.9529 12.7194L2.5 6.41658V5.92801ZM2.5 8.5623V18.0709C2.5 18.6392 2.72576 19.1842 3.12763 19.5861C3.52949 19.988 4.07454 20.2137 4.64286 20.2137H20.3571C20.9255 20.2137 21.4705 19.988 21.8724 19.5861C22.2742 19.1842 22.5 18.6392 22.5 18.0709V8.5623L14.0329 14.208L14.0257 14.2137C13.5698 14.5033 13.0401 14.6555 12.5 14.6523C11.9643 14.6523 11.4243 14.5066 10.9743 14.2137L10.9671 14.208L2.5 8.5623Z" fill="#C0C3C9"/>
                    </svg>
                </span>
                <span class="text">Email</span>
            </span>
            <a v-if="socials.facebook" :href="socials.facebook.url" @click.prevent="$emit('link-social', socials.facebook.url)" class="social__link facebook">
                <span class="icon">
                    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.28 13.249L17.84 9.65527H14.28V7.31152C14.28 6.2959 14.76 5.3584 16.36 5.3584H18V2.27246C18 2.27246 16.52 1.99902 15.12 1.99902C12.2 1.99902 10.28 3.75684 10.28 6.88184V9.65527H7V13.249H10.28V21.999H14.28V13.249H17.28Z" fill="#C0C3C9"/>
                    </svg>
                </span>
                <span class="text">Facebook</span>
            </a>
            <a v-else-if="socials.vkontakte" :href="socials.vkontakte.url" @click.prevent="$emit('link-social', socials.vkontakte.url)" class="social__link vkontakte">
                <span class="icon">
                    <svg data-v-75b860ea="" width="22" height="12" viewBox="0 0 22 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path data-v-75b860ea="" d="M5.217 1.3036C5.79218 2.72402 6.52114 4.06323 7.48123 5.26547C7.60857 5.42546 7.76909 5.5677 7.93819 5.6835C8.18517 5.85313 8.41821 5.79351 8.51863 5.51098C8.62485 5.21449 8.72233 4.61361 8.72813 4.30227C8.74398 3.48873 8.72576 2.95558 8.68205 2.14305C8.65371 1.62263 8.46871 1.16568 7.70321 1.02776C7.4668 0.984993 7.44484 0.790405 7.59672 0.59629C7.91291 0.192157 8.35338 0.12775 8.83103 0.102262C9.60517 0.0604476 10.3822 0.094573 11.1572 0.102262C11.473 0.105158 11.7906 0.130595 12.1015 0.198371C12.507 0.286792 12.7242 0.571276 12.791 0.967193C12.8256 1.17142 12.8434 1.38139 12.8386 1.58803C12.8184 2.47603 12.7757 3.36355 12.7656 4.25108C12.7612 4.59944 12.7867 4.95649 12.8612 5.29575C12.9655 5.76855 13.2874 5.88725 13.6166 5.54563C14.0346 5.11174 14.4032 4.62351 14.7492 4.12764C15.3777 3.22568 15.8471 2.23584 16.2512 1.21523C16.4603 0.688607 16.6203 0.574225 17.1868 0.572803C18.2516 0.57038 19.3165 0.569432 20.3813 0.572803C20.5702 0.573751 20.7677 0.591551 20.9459 0.648268C21.2352 0.740533 21.35 0.976462 21.2823 1.27585C21.1242 1.97742 20.7451 2.57372 20.339 3.14701C19.6874 4.06671 19.0046 4.96434 18.3377 5.87346C18.2526 5.98926 18.1777 6.11276 18.108 6.23815C17.8586 6.68888 17.8759 6.94161 18.2396 7.31689C18.8187 7.91419 19.4386 8.47299 19.9993 9.08662C20.4068 9.53304 20.784 10.0174 21.1069 10.5272C21.5154 11.1721 21.263 11.7794 20.5 11.8875C20.02 11.9553 17.6751 11.8881 17.554 11.8875C16.9235 11.8847 16.371 11.666 15.926 11.2379C15.431 10.7612 14.9812 10.2384 14.506 9.74105C14.3628 9.59112 14.21 9.44746 14.0452 9.32202C13.6565 9.02553 13.2749 9.09136 13.0933 9.54789C12.9381 9.94001 12.804 10.9697 12.7977 11.0577C12.7651 11.5175 12.4724 11.8106 11.9573 11.839C10.4701 11.9197 9.02899 11.7539 7.68646 11.0346C6.54858 10.4253 5.63994 9.56374 4.85284 8.55899C3.60252 6.9631 2.61494 5.20885 1.7133 3.4031C1.66722 3.31079 0.754001 1.36753 0.72946 1.27574C0.647886 0.968404 0.723983 0.67481 0.983663 0.573751C1.14555 0.510766 4.15648 0.57354 4.20656 0.576226C4.68701 0.602241 5.01462 0.80494 5.217 1.3036Z" fill="#C0C3C9"></path>
                    </svg>
                </span>
                <span class="text">Vkontakte</span>
            </a>
            <a v-if="socials.twitch" :href="socials.twitch.url" @click.prevent="$emit('link-social', socials.twitch.url)" class="social__link twitch">
                <span class="icon">
                    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.9997 11.2842L17.003 14.1436H14.0023L11.3767 16.6456V14.1436H8.00099V3.42873H19.9997V11.2842ZM7.25082 1.99902L3.5 5.56932V18.4287H8.00099V21.999L11.7518 18.4287H14.7525L21.5 11.999V1.99902H7.25082ZM17.7531 6.04191H16.2528V10.3271H17.7531V6.04191ZM12.1269 6.02206H13.6272V10.3072H12.1269V6.02206Z" fill="#C0C3C9"/>
                    </svg>
                </span>
                <span class="text">Twitch</span>
            </a>
            <a v-if="socials.microsoft" :href="socials.microsoft.url" @click.prevent="$emit('link-social', socials.microsoft.url)" class="social__link microsoft">
                <span class="icon">
                    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="2.5" y="2" width="9.375" height="9.375" fill="#C0C3C9"/>
                        <rect x="2.5" y="12.625" width="9.375" height="9.375" fill="#C0C3C9"/>
                        <rect x="13.125" y="2" width="9.375" height="9.375" fill="#C0C3C9"/>
                        <rect x="13.125" y="12.625" width="9.375" height="9.375" fill="#C0C3C9"/>
                    </svg>
                </span>
                <span class="text">Microsoft</span>
            </a>
            <div class="social__block-slide" v-if="socials.yandex">
                <SlideUpDown :isActive="isActive">
                    <div class="social__block-slide-block">
                        <a :href="socials.yandex.url" @click.prevent="$emit('link-social', socials.yandex.url)" class="social__link yandex">
                            <span class="icon">
                                <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14.328 3H12.493C9.613 3 7.853 4.74 7.853 7.18C7.853 9.97 9.073 11.22 11.543 12.82L13.598 14.14L7.998 21H5.498L10.648 14.78L8.988 13.71C6.128 11.85 4.643 10.18 4.643 7.27C4.643 3.64 7.248 1 12.498 1H17.538V21H14.328V3Z" fill="#C0C3C9"/>
                                </svg>
                            </span>
                            <span class="text">Yandex</span>
                        </a>
                    </div>
                </SlideUpDown>
                <span class="social__block-btn" :class="{active: isActive}" @click="isActive = !isActive">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 12.5L10 7.5L15 12.5" stroke="#9CA3AF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import SlideUpDown from '/webpack-assets/vue/components/SlideUpDown.vue';

export default {
    components: {
      SlideUpDown
    },
    props: {
        socials: {
            type: Object,
        },
        isDifmark: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            isActive: false,
        }
    }
}
</script>

<style scoped lang="scss">
    .social{
        &__block{
            margin-top: 20px;
            padding-top: 20px;
            border-top: 1px solid rgba(31, 31, 31, 0.10);
            display: flex;
            flex-wrap: wrap;
            gap: 20px;
            & > .social__link {
                flex: 0 1 calc(50% - 10px);
            }
            &-slide{
                margin-top: 0;
                border-top: none;
                padding-top: 0;
                display: flex;
                gap: 0;
                flex-direction: column;
                width: 100%;
                &-block{
                    display: flex;
                    gap: 20px;
                    .social__link{
                        width: 100%;
                    }
                }
            }
            &-btn{
                display: flex;
                cursor: pointer;
                width: 100%;
                padding-top: 10px;
                margin-bottom: -10px;
                justify-content: center;
                transition: 0.4s;
                svg{
                    transition: 0.4s;
                    transform: rotate(-180deg);
                    path { stroke: #9CA3AF; }
                }
                &.active{
                    svg{
                        transform: rotate(0deg);
                    }
                }
            }
            .social__link{
                .icon svg path, .icon svg rect {
                    fill: #605F61 !important;
                }
                &.email:hover{
                    background-color: #E74C3C;
                    .text { color: #fff; }
                    .icon svg path { fill: #fff !important; }
                }
                &.facebook:hover{
                    background-color: #1877F2;
                    .text { color: #fff; }
                    .icon svg path { fill: #fff !important; }
                }
                &.twitch:hover{
                    background-color: #6441A5;
                    .text { color: #fff; }
                    .icon svg path { fill: #fff !important; }
                }
                &.microsoft:hover{
                    background-color: #00A4EF;
                    .text { color: #fff; }
                    .icon svg path, .icon svg rect { fill: #fff !important; }
                }
                &.yandex:hover{
                    background-color: #FC3F1D;
                    .text { color: #fff; }
                    .icon svg path { fill: #fff !important; }
                }
                &.vkontakte:hover{
                    background-color: #4C75A3;
                    .text { color: #fff; }
                    .icon svg path { fill: #fff !important; }
                }
                &.steam:hover, &.discord:hover{
                    background-color: #5865F2;
                    .text { color: #fff; }
                    .icon svg path { fill: #fff !important; }
                }
            }
        }
        &__link{
            height: 48px;
            cursor: pointer;
            border-radius: 8px;
            background-color: #F6F5FA;
            border: none;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 8px;
            transition: 0.3s;
            &.google{
                background-color: rgba(78, 138, 255, 0.1);
                border: none;
                .text{
                    color: #11151A;
                    font-family: 'Avenir-Next', sans-serif;
                    font-size: 14px;
                    :deep(span){
                        font-family: 'Avenir-Next-DemiBold', sans-serif;
                    }
                }
                &:hover{
                    background-color: rgba(78, 138, 255, 0.15);
                }
            }
            .icon{
                width: 20px;
                height: 20px;
                svg{
                    width: 20px;
                    height: 20px;
                    rect,
                    path{
                        transition: 0.3s;
                    }
                }
            }
            .text{
                font-family: 'Avenir-Next-DemiBold', sans-serif;
                font-weight: 600;
                font-size: 14px;
                line-height: 140%;
                color: #605F61;
                transition: 0.3s;
                :deep(span){
                    font-family: 'Roboto-Medium';
                }
            }
        }
    }
</style>